import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {UpgradeArrow} from 'shells/limits/upgrade-arrow';
import {Body} from 'shells/typography/body';

import {AiUsageSection} from '.';

type Props = {
    isEnabled: boolean;
    setIsEnabled: (isEnabled: boolean) => void;
};

export function AiEmailRepliesSection(props: Props) {
    const emailRepliesHeader = (
        <Body isBold={true} color='dark' size='large'>
            Email replies
        </Body>
    );

    return NutClientConfig.hasAiEmailReplies ? (
        <StackLegacy spacing={8}>
            {emailRepliesHeader}
            <AiUsageSection
                setIsEnabled={props.setIsEnabled}
                isEnabled={props.isEnabled}
                description='Suggest AI-generated email replies.'
                title='Email replies usage'
                link='https://support.nutshell.com/en/articles/11255871-ai-using-ai-email-reply-starters'
                alternateUsageSummary='You have unlimited suggestions available.'
                unit='suggestions'
            />
        </StackLegacy>
    ) : (
        <StackLegacy spacing={8}>
            <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                {emailRepliesHeader}
                <div className='pt-4'>
                    <UpgradeArrow
                        featureName='AI email replies'
                        title='Upgrade your plan to Nutshell Pro or higher to gain access to this feature.'
                    />
                </div>
            </StackLegacy>
            <Checkbox label='Suggest AI-generated email replies.' checked={false} disabled={true} />
        </StackLegacy>
    );
}
